import { Injectable } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FieldSchema } from '@vendasta/auxiliary-data-components';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, map, skip } from 'rxjs/operators';

/*
FIXME this should be named something like
  CustomFieldEditorNotificationsService
  but that should be a separate PR since it'll hide the actual changes in
  the file / everything renames
*/
@Injectable({
  providedIn: 'root',
})
export class FieldSelectedForEditService {
  private selectedFieldId$$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  selectedFieldId$: Observable<string> = this.selectedFieldId$$.asObservable().pipe(filter((id) => id !== null));
  editClicked$: Observable<void> = this.selectedFieldId$.pipe(map(() => null));
  createClicked$: Observable<void> = this.selectedFieldId$$.asObservable().pipe(
    filter((id) => id === null),
    skip(1),
    map(() => {
      // do nothing
    }),
  );
  fieldCreated$$: Subject<FieldSchema> = new Subject<FieldSchema>();

  createNewFieldClicked(): void {
    this.selectedFieldId$$.next(null);
  }

  editClickedForField(fieldId: string): void {
    this.selectedFieldId$$.next(fieldId);
  }
}
